import { render, staticRenderFns } from "./Attendees.vue?vue&type=template&id=e2241336&scoped=true&"
import script from "./Attendees.vue?vue&type=script&lang=js&"
export * from "./Attendees.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2241336",
  null
  
)

export default component.exports